import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import { Link as RouterLink } from '../../router/components/Link'
import { usePageInfo } from '../hooks/usePageInfo'

export { Breadcrumbs, type BreadcrumbTrail }

type BreadcrumbTrail = [] | [...Breadcrumb[], Pick<Breadcrumb, 'label'>]

type Breadcrumb = {
  label: string
  href: string
  tooltip: string
}

const Breadcrumbs = () => {
  const { breadcrumbs } = usePageInfo()

  if (breadcrumbs.length === 0) {
    return null
  }

  return (
    <MuiBreadcrumbs>
      {breadcrumbs.map((breadcrumb, index) => {
        if ('href' in breadcrumb) {
          return (
            <Tooltip key={index} title={breadcrumb.tooltip}>
              <Link
                component={RouterLink}
                to={breadcrumb.href}
                underline="hover"
                color="inherit"
              >
                {breadcrumb.label}
              </Link>
            </Tooltip>
          )
        }

        return (
          <Typography
            key={index}
            sx={{
              color: 'text.primary',
            }}
          >
            {breadcrumb.label}
          </Typography>
        )
      })}
    </MuiBreadcrumbs>
  )
}
